module.exports = __webpack_public_path__ + "static/media/leitura-news-roman-3.1b28435c.otf";